import { ModalAction } from '../commonComponents/bottomModal/ActionItem';
import config from '../config.general';
import { loginPageUrl, resetPasswordPageUrl } from '../core/constants';
import { ApiResultMessages, MessageTypes } from '../core/enums';

export interface ApiResultMessageModel {
	title: string;
	description: string[];
	errorType?: MessageTypes;
	actions?: ModalAction[];
}

export const ApiResultMessagesList: ApiResultMessageModel[] = [
	{
		title: ApiResultMessages.AccountAwaitingApproval,
		description: [
			"Thanks for signing up. Your account is pending approval and may take up to 24 hours. We'll email you when it's ready."
		],
		errorType: MessageTypes.Information,
		actions: [
			{
				label: 'Contact app support',
				emailHref: `mailto:${config.appSupportEmail}`
			}
		]
	},
	{
		title: ApiResultMessages.AccountAlreadyExists,
		description: [
			'An account with these details already exists. Please reset your password or return to the login screen.'
		],
		errorType: MessageTypes.Error,
		actions: [
			{ label: 'Reset password', internalLink: resetPasswordPageUrl },
			{ label: 'Return to login screen', internalLink: loginPageUrl }
		]
	},
	{
		title: ApiResultMessages.ClientAccountLocked,
		description: [
			"We've had to lock your account due to security reasons. Please get in touch with app support to unlock your account."
		],
		errorType: MessageTypes.Error,
		actions: [
			{
				label: 'Contact app support',
				emailHref: `mailto:${config.appSupportEmail}`
			}
		]
	}
];

export const getAndValidateApiMessage = (
	apiResponse: string,
	withCallbackTitle?: ApiResultMessages,
	actionCallback?: () => Promise<void>
) => {
	const apiMessage = ApiResultMessagesList.find((msg) => msg.title === apiResponse);
	if (!apiMessage) throw new Error(`API error was not found in ApiResultMessagesList: ${apiResponse}`);

	// TODO: Consider to delete this block if not needed anymore
	if (apiMessage.title === withCallbackTitle && !!actionCallback) {
		return {
			...apiMessage,
			actions: apiMessage.actions.map((action) => (action.callback ? { ...action, callback: actionCallback } : action))
		};
	}

	return apiMessage;
};
